import React from "react";
import { Paginator } from "@orange-marmalade/paginate-this";
import PropTypes from "prop-types";

export default function Pagination({ listId }) {
  return <Paginator listId={listId} />;
}

Pagination.propTypes = {
  listId: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Pagination/Pagination.jsx